// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"support_wrapper__5Z_EV","card":"support_card__XStco","content":"support_content__aOGap","mail":"support_mail__BIQT_"};